import React, { Component } from 'react';

import SizePanel from './containers/SizePanelContainer';
import TestPanel from './containers/TestPanelContainer';

import styles from './style';

export default class ControlPanel extends Component {
  render() {
    return (
      <div className={styles['control_container']}>
        <SizePanel />
        {/* <div className={styles['gap']} /> */}
        {/* <div className={styles['gap']} /> */}
        <TestPanel />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/control_panel/ControlPanel.jsx